import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Requests a settings reset whenever the collection context changes. */
export const resetOnContextChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(action => feature.actions.reset.request.from(action).create()),
      ),
)
